// The chat's icons (Material Symbols, Outlined), in the signed-in chunk only.
import addReaction from '@material-symbols/svg-400/outlined/add_reaction.svg?raw';
import add from '@material-symbols/svg-400/outlined/add.svg?raw';
import bookmarkFill from '@material-symbols/svg-400/outlined/bookmark-fill.svg?raw';
import mic from '@material-symbols/svg-400/outlined/mic.svg?raw';
import pause from '@material-symbols/svg-400/outlined/pause.svg?raw';
import refresh from '@material-symbols/svg-400/outlined/refresh.svg?raw';
import block from '@material-symbols/svg-400/outlined/block.svg?raw';
import call from '@material-symbols/svg-400/outlined/call.svg?raw';
import callEnd from '@material-symbols/svg-400/outlined/call_end.svg?raw';
import deleteIcon from '@material-symbols/svg-400/outlined/delete.svg?raw';
import description from '@material-symbols/svg-400/outlined/description.svg?raw';
import download from '@material-symbols/svg-400/outlined/download.svg?raw';
import edit from '@material-symbols/svg-400/outlined/edit.svg?raw';
import flag from '@material-symbols/svg-400/outlined/flag.svg?raw';
import forum from '@material-symbols/svg-400/outlined/forum.svg?raw';
import image from '@material-symbols/svg-400/outlined/image.svg?raw';
import keep from '@material-symbols/svg-400/outlined/keep.svg?raw';
import keyboard from '@material-symbols/svg-400/outlined/keyboard.svg?raw';
import keepOff from '@material-symbols/svg-400/outlined/keep_off.svg?raw';
import link from '@material-symbols/svg-400/outlined/link.svg?raw';
import login from '@material-symbols/svg-400/outlined/login.svg?raw';
import logout from '@material-symbols/svg-400/outlined/logout.svg?raw';
import mood from '@material-symbols/svg-400/outlined/mood.svg?raw';
import notifications from '@material-symbols/svg-400/outlined/notifications.svg?raw';
import notificationsActive from '@material-symbols/svg-400/outlined/notifications_active.svg?raw';
import notificationsOff from '@material-symbols/svg-400/outlined/notifications_off.svg?raw';
import notificationsUnread from '@material-symbols/svg-400/outlined/notifications_unread.svg?raw';
import person from '@material-symbols/svg-400/outlined/person.svg?raw';
import personAdd from '@material-symbols/svg-400/outlined/person_add.svg?raw';
import personRemove from '@material-symbols/svg-400/outlined/person_remove.svg?raw';
import play from '@material-symbols/svg-400/outlined/play_arrow.svg?raw';
import remove from '@material-symbols/svg-400/outlined/remove.svg?raw';
import reply from '@material-symbols/svg-400/outlined/reply.svg?raw';
import alarm from '@material-symbols/svg-400/outlined/alarm.svg?raw';
import arrowUp from '@material-symbols/svg-400/outlined/keyboard_arrow_up.svg?raw';
import group from '@material-symbols/svg-400/outlined/group.svg?raw';
import send from '@material-symbols/svg-400/outlined/send.svg?raw';
import sendFill from '@material-symbols/svg-400/outlined/send-fill.svg?raw';
import textFormat from '@material-symbols/svg-400/outlined/text_format.svg?raw';
import unfoldLess from '@material-symbols/svg-400/outlined/unfold_less.svg?raw';
import unfoldMore from '@material-symbols/svg-400/outlined/unfold_more.svg?raw';
import visibility from '@material-symbols/svg-400/outlined/visibility.svg?raw';
import warning from '@material-symbols/svg-400/outlined/warning.svg?raw';

export const chatIcons = {
  add, addReaction, alarm, arrowUp, group, block, bookmarkFill, call, callEnd, delete: deleteIcon, description, download, edit, flag, forum,
  image, keep, keepOff, keyboard, link, login, logout, mic, mood, pause, refresh, notifications, notificationsActive, notificationsOff, notificationsUnread, person, personAdd,
  personRemove, play, remove, reply, schedule, send, sendFill, textFormat, unfoldLess, unfoldMore, visibility, warning,
};

import search from '@material-symbols/svg-400/outlined/search.svg?raw';
import schedule from '@material-symbols/svg-400/outlined/schedule.svg?raw';
import eco from '@material-symbols/svg-400/outlined/eco.svg?raw';
import cafe from '@material-symbols/svg-400/outlined/local_cafe.svg?raw';
import ball from '@material-symbols/svg-400/outlined/sports_soccer.svg?raw';
import photo from '@material-symbols/svg-400/outlined/photo.svg?raw';
import bulb from '@material-symbols/svg-400/outlined/lightbulb.svg?raw';
import symbols from '@material-symbols/svg-400/outlined/emoji_symbols.svg?raw';
import flagIcon from '@material-symbols/svg-400/outlined/flag.svg?raw';

/** The emoji board's icons: search, recent, packs, the eight standard groups. */
export const emojiIcons = {
  search, schedule, mood,
  smileys: mood, animals: eco, food: cafe, activity: ball, travel: photo, objects: bulb, symbols, flags: flagIcon,
};
